import React, { useState } from 'react';

import {
  ThumbsDownSolidIcon,
  ThumbsUpSolidIcon
} from '../../../../shared/icons/icons';

import './review-feedback.scss';

interface ReviewFeedbackProps {
  helpfulCount?: number;
  id: string;
  isFeedbackSubmitted?: boolean;
  isReportLabel?: boolean;
  notHelpfulCount?: number;
  onHelpfulClick?: (id: string, isHelpful: boolean) => void;
}

function ReviewFeedback(props: ReviewFeedbackProps) {
  const {
    helpfulCount,
    id,
    isFeedbackSubmitted,
    isReportLabel = false,
    notHelpfulCount,
    onHelpfulClick
  } = props;

  const [hasSubmittedFeedback, setHasSubmittedFeedback] =
    useState(isFeedbackSubmitted);

  function submitHelpfulFeedback() {
    setHasSubmittedFeedback(true);
    if (onHelpfulClick) {
      onHelpfulClick(id, true);
    }
  }

  function submitNotHelpfulFeedback() {
    setHasSubmittedFeedback(true);
    if (onHelpfulClick) {
      onHelpfulClick(id, false);
    }
  }
  return (
    <div className="review-feedback" styleName="container">
      {hasSubmittedFeedback ? (
        <span styleName="helpful-message-thanks">
          Thank you for your feedback!
        </span>
      ) : (
        <>
          <span styleName="helpful-message">
            Was this {isReportLabel ? 'report' : 'review'} helpful?
          </span>
          <div styleName="helpful-feedback">
            <button
              aria-label="Submit feedback review helpful"
              className="review-feedback__feedback-button"
              onClick={submitHelpfulFeedback}
              styleName="feedback-button"
              type="button"
            >
              <ThumbsUpSolidIcon styleName="feedback-icon" />
              {helpfulCount}
            </button>

            <button
              aria-label="Submit feedback review not helpful"
              className="review-feedback__feedback-button"
              onClick={submitNotHelpfulFeedback}
              styleName="feedback-button"
              type="button"
            >
              <ThumbsDownSolidIcon styleName="feedback-icon" />
              {notHelpfulCount}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default ReviewFeedback;
